module.exports = __webpack_public_path__ + "static/scientist7-65108fa6304f8f419e0722d2d3ea7740.png";